import Button from "@/components/ui/button/Button";
import Alert from "@/components/ui/alert/Alert";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import Label from "@/components/Usados/Label";
import Input from "@/components/Usados/InputField";
import Select from "@/components/Usados/Select";
import Autocomplete from "@/components/Usados/AutoComplete";
import { apiFetch } from "@/service/api";

export default function CrearMovimiento({
  movimiento,
  onSuccess,
  onCancel,
}: any) {
  const { id: proyecto_id } = useParams();
  const isEdit = !!movimiento;
  const [form, setForm] = useState<any>({
    tipo: "1",
    valor: "",
    descripcion: "",
    actividad_id: "",
  });
  const [actividades, setActividades] = useState<any[]>([]);
  const [capital, setCapital] = useState<number>(0);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (movimiento)
      setForm({
        tipo: movimiento.tipo?.toString() || "1",
        valor: movimiento.valor?.toString() || "",
        descripcion: movimiento.descripcion || "",
        actividad_id:
          movimiento.actividad?.id?.toString() ||
          movimiento.actividad_id?.toString() ||
          "",
      });
    apiFetch(`actividades-proyectos/find-all-proyecto/${proyecto_id}`)
      .then((r) => r.json())
      .then((d) =>
        setActividades(
          d.map((a: any) => ({
            value: a.id.toString(),
            label: `${a.nombre} - $${Number(a.costo || 0).toLocaleString()}`,
          })),
        ),
      )
      .catch(() => {});
    apiFetch(`movimientos/presupuesto/${proyecto_id}`)
      .then((r) => r.json())
      .then((d) => setCapital(d.restanteDinamico))
      .catch(() => {});
  }, [movimiento, proyecto_id]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setError(null);
    if (Number(form.tipo) === 2 && Number(form.valor) > capital && !isEdit) {
      setError(
        `No hay suficiente capital. Disponible: $${capital.toLocaleString()}`,
      );
      return;
    }
    const url = isEdit ? `movimientos/${movimiento.id}` : `movimientos/create`;
    const method = isEdit ? "PATCH" : "POST";
    const payload = {
      proyecto_id: Number(proyecto_id),
      tipo: Number(form.tipo),
      valor: Number(form.valor),
      descripcion: form.descripcion,
      actividad_id: form.actividad_id ? Number(form.actividad_id) : null,
    };
    const res = await apiFetch(url, { method, body: JSON.stringify(payload) });
    const data = await res.json();
    if (!res.ok) {
      setError(data.message);
      return;
    }
    setSuccess(true);
    setTimeout(() => onSuccess?.(), 800);
  };

  return (
    <div className="rounded-2xl border border-gray-200 bg-white px-5 py-7 dark:border-gray-800 dark:bg-white/[0.03] xl:px-10 xl:py-12">
      <h3 className="mb-8 font-semibold text-gray-800 text-center text-theme-xl dark:text-white/90 sm:text-2xl">
        {isEdit ? "Editar Movimiento" : "Crear Movimiento"}
      </h3>
      {error && <Alert variant="error" title="Error" message={error} />}
      {success && (
        <Alert variant="success" title="Éxito" message="Movimiento guardado" />
      )}
      <div className="mb-6 text-sm bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 max-w-2xl mx-auto">
        Capital disponible (con costos de actividades descontados):{" "}
        <b>${capital.toLocaleString()}</b>
      </div>
      <form onSubmit={handleSubmit} className="space-y-6 max-w-2xl mx-auto">
        <div>
          <Label>Tipo (Ingreso/Gasto)</Label>
          <Select
            value={form.tipo || "1"}
            onChange={(v: any) => setForm({ ...form, tipo: v })}
            options={[
              { value: "1", label: "Ingreso" },
              { value: "2", label: "Gasto" },
            ]}
          />
        </div>
        <div>
          <Autocomplete
            label="Ligar a Actividad (opcional)"
            options={actividades}
            value={form.actividad_id || ""}
            onChange={(id: any) => setForm({ ...form, actividad_id: id })}
            placeholder="Seleccione actividad para vincular"
          />
        </div>
        <div>
          <Label>Valor</Label>
          <Input
            type="number"
            value={form.valor || ""}
            onChange={(e: any) => setForm({ ...form, valor: e.target.value })}
            required
          />
        </div>
        <div>
          <Label>Descripción</Label>
          <Input
            value={form.descripcion || ""}
            onChange={(e: any) =>
              setForm({ ...form, descripcion: e.target.value })
            }
            required
          />
        </div>
        <div className="flex gap-3 pt-4">
          <Button type="submit">
            {isEdit ? "Actualizar" : "Crear"} Movimiento
          </Button>
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancelar
          </Button>
        </div>
      </form>
    </div>
  );
}
